import React, { useContext } from 'react';

import { WindowContext } from '../../providers';

interface VisibleOn {
    reverse?: boolean;
    mobile?: boolean;
    tablet?: boolean;
    desktop?: boolean;
}

/**
 * Allows to conditionally render its children based on screen size.
 * @example
 * // Displays text only on desktop
 * <Visible desktop> hi! </VisibleOn>
 *
 * // Displays text on every screen but desktop
 * <Visible reverse desktop> hi! </VisibleOn>
 */
export const VisibleOn: React.FC<VisibleOn> = ({
    children,
    reverse = false,
    ...sizeNames
}) => {
    const { currentMediaName } = useContext(WindowContext);

    if (
        (reverse && sizeNames[currentMediaName]) ||
        (!reverse && !sizeNames[currentMediaName])
    ) {
        return null;
    }

    return <>{children}</>;
};
